import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Buttons from "./Buttons";
export default function EditTechnologies({type, editTechnologies,setOpen = () => {} }) {
  const dispatch = useDispatch();
  const { resume, employeeId } = useSelector(({ skillsReducer }) => {
    return {
      resume: skillsReducer?.resume,
      employeeId: skillsReducer?.employeeId,
    };
  });
  const [technologies, setTechnologies] = useState((prev) => {
    const technologies = resume?.[type]?.[employeeId]?.TECHNOLOGIES
      ? resume?.[type]?.[employeeId]?.TECHNOLOGIES?.join("\n\n")
      : "";
    return technologies;
  });
  const onChangeHandler = (e) => {
    setTechnologies(e.target?.value);
  };
  const saveHandler = (e) => {
    e.preventDefault();
    const newTechnologies = technologies?.split("\n");
    const newArr = newTechnologies?.reduce((acc, item) => {
      if (item !== "") {
        return [...acc, item];
      } else {
        return [...acc];
      }
    }, []);
    dispatch(editTechnologies( newArr,employeeId));
    setOpen(false);
  };
  const style = {
    display: "flex",
    gap: "24px",
    flexDirection: "column",
    width: "800px",
    minHeight: "400px",
    maxHeight: "600px",
  };
  const textareaStyle = {
   width:"100%",
    minHeight: "400px",
    padding: "19px 16px",
    boxSizing: "border-box",
    border: "1px solid #DCDCDC",
    borderRadius: "8px",
    resize: "none",
    fontFamily: "'Montserrat'",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    color: "#1D2C34",
  };
  return (
    <form style={{ ...style }} onSubmit={saveHandler}>
      <textarea
        placeholder="Edit Technologies"
        value={technologies}
        onChange={onChangeHandler}
        style={{ ...textareaStyle }}
      />
      <Buttons
        saveHandler={() => {}}
        cancelationHandler={() => {
          setOpen(false);
        }}
      />
    </form>
  );
}
